'use client'

import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { SESSION_EXPIRED_MESSAGE } from '~/services/core/ApiService'
import { endSessionService } from '~/services/domain/auth/SessionService'

interface ISessionExpiredDetail {
    type?: string
    message?: string
}

/**
 * Ouve o evento `sessionExpired` (401 de uma chamada com o token, update-token recusado, cache sem token): encerra a
 * sessão por completo (o 401 do interceptor apaga só o token, não a marca de suporte), descarta o cache do React Query
 * e chama `onExpired` com a mensagem, para a casca avisar e mandar para o login.
 */
export function useSessionExpired(onExpired: (message: string) => void) {
    const queryClient = useQueryClient()
    const callback = useRef(onExpired)
    useEffect(() => {
        callback.current = onExpired
    })

    useEffect(() => {
        const handle = (event: Event) => {
            const detail = (event as CustomEvent<ISessionExpiredDetail>).detail
            if (detail?.type !== 'sessionExpired') return
            endSessionService()
            queryClient.clear()
            callback.current(detail.message || SESSION_EXPIRED_MESSAGE)
        }

        window.addEventListener('sessionExpired', handle)
        return () => window.removeEventListener('sessionExpired', handle)
    }, [queryClient])
}
